var map = {
	"./Approved.svg": 3844,
	"./AwaitingParts.svg": 3845,
	"./Closed.svg": 3846,
	"./Completed.svg": 3847,
	"./Excel.svg": 3848,
	"./Exportall_grey.svg": 3849,
	"./Exportall_grey_circle.svg": 3850,
	"./InProgress.svg": 3851,
	"./New.svg": 3852,
	"./View_Pic_Grey.svg": 3853,
	"./accident.svg": 3854,
	"./account.svg": 3855,
	"./addOrange.svg": 3856,
	"./addUser.svg": 3857,
	"./addVehicle.svg": 3858,
	"./address.svg": 3859,
	"./alert.svg": 3860,
	"./all_active.svg": 3861,
	"./all_active_es.svg": 3862,
	"./arrow-down.svg": 3863,
	"./arrow-up.svg": 3864,
	"./arrowRight.svg": 3865,
	"./awaiting_parts_grey.svg": 3866,
	"./awaiting_parts_orange.svg": 3867,
	"./back-btn.svg": 3868,
	"./back-button-grey.svg": 3869,
	"./backButton.svg": 3870,
	"./bills_of_landing_active.svg": 3871,
	"./bills_of_landing_active_es.svg": 3872,
	"./bobTail.svg": 3873,
	"./book-solid.svg": 3874,
	"./boxTruck.svg": 3875,
	"./calanderIcon.svg": 3876,
	"./cameraSelected.svg": 3877,
	"./camera_selected.svg": 3878,
	"./chat-icon.svg": 3879,
	"./circle-Exportall_grey.svg": 3880,
	"./circle-export.svg": 3881,
	"./circle-exportUser.svg": 3882,
	"./circle-import.svg": 3883,
	"./circle-importUser.svg": 3884,
	"./circle-viewall.svg": 3885,
	"./clearAll.svg": 3886,
	"./close-popup.svg": 3887,
	"./closeMap.svg": 3888,
	"./closed-Orange.svg": 3889,
	"./closed-grey.svg": 3890,
	"./clusterIcon.svg": 3891,
	"./communication_records_active.svg": 3892,
	"./communication_records_active_es.svg": 3893,
	"./company.svg": 3894,
	"./companyIcon.svg": 3895,
	"./complete-Orange.svg": 3896,
	"./complete-grey.svg": 3897,
	"./csa.svg": 3898,
	"./csaSnapshot.svg": 3899,
	"./dailyDocuments.svg": 3900,
	"./dashboard.svg": 3901,
	"./dashboardIcon.svg": 3902,
	"./date.svg": 3903,
	"./delete.svg": 3904,
	"./deleteCircle.svg": 3905,
	"./delivery_receipts_active.svg": 3906,
	"./delivery_receipts_active_es.svg": 3907,
	"./departments.svg": 3908,
	"./departmetEdit.svg": 3909,
	"./developer.svg": 3910,
	"./direction.svg": 3911,
	"./dispatch_records_active.svg": 3912,
	"./dispatch_records_active_es.svg": 3913,
	"./document.svg": 3914,
	"./documents.svg": 3915,
	"./dot.svg": 3916,
	"./dotAudit.svg": 3917,
	"./dotauditIcon.svg": 3918,
	"./downarrowIcon.svg": 3919,
	"./download.svg": 3920,
	"./downloadCenter.svg": 3921,
	"./downloadCenterMenu.svg": 3922,
	"./driver-behaviour.svg": 3923,
	"./driver.svg": 3924,
	"./dryVan.svg": 3925,
	"./dtc.svg": 3926,
	"./dualCam.svg": 3927,
	"./dump.svg": 3928,
	"./edit.svg": 3929,
	"./editLogIcon.svg": 3930,
	"./editSvg.svg": 3931,
	"./en.svg": 3932,
	"./es.svg": 3933,
	"./excelNew.svg": 3934,
	"./export-grey.svg": 3935,
	"./export.svg": 3936,
	"./exportUser.svg": 3937,
	"./feedback.svg": 3938,
	"./file-pdf-regular.svg": 3939,
	"./filter.svg": 3940,
	"./flatBed.svg": 3941,
	"./fleet.svg": 3942,
	"./fleetCompanies.svg": 3943,
	"./fleetdriverIcon.svg": 3944,
	"./fleetvehiclesIcon.svg": 3945,
	"./fletBed.svg": 3946,
	"./fr.svg": 3947,
	"./fuel.svg": 3948,
	"./full.svg": 3949,
	"./hamburger.svg": 3950,
	"./help-icon.svg": 3951,
	"./historyLogs.svg": 3952,
	"./icon-delete.svg": 3953,
	"./icon-export.svg": 3954,
	"./icon-menu-logs.svg": 3955,
	"./ifta.svg": 3956,
	"./import.svg": 3957,
	"./importUser.svg": 3958,
	"./in_progress_grey.svg": 3959,
	"./in_progress_orange.svg": 3960,
	"./infoTruck.svg": 3961,
	"./inspection-dvir.svg": 3962,
	"./inspection.svg": 3963,
	"./key.svg": 3964,
	"./leftArrow.svg": 3965,
	"./location.svg": 3966,
	"./locationMap.svg": 3967,
	"./log.svg": 3968,
	"./logEdit.svg": 3969,
	"./logHistory.svg": 3970,
	"./logoutIcon.svg": 3971,
	"./logs.svg": 3972,
	"./logsIcon.svg": 3973,
	"./mack.svg": 3974,
	"./mail.svg": 3975,
	"./main_camera.svg": 3976,
	"./mappinPopup.svg": 3977,
	"./menu_companies.svg": 3978,
	"./menu_dailyLog.svg": 3979,
	"./menu_reports.svg": 3980,
	"./menu_reseller.svg": 3981,
	"./menu_vehicle.svg": 3982,
	"./messageSender.svg": 3983,
	"./messaging.svg": 3984,
	"./new_login.svg": 3985,
	"./ninePin.svg": 3986,
	"./nonEdit.svg": 3987,
	"./notFull.svg": 3988,
	"./not_started_grey.svg": 3989,
	"./not_started_orange.svg": 3990,
	"./otherTrailer.svg": 3991,
	"./otherTruck.svg": 3992,
	"./other_documents_active.svg": 3993,
	"./other_documents_active_es.svg": 3994,
	"./overview.svg": 3995,
	"./page-first.svg": 3996,
	"./page-last.svg": 3997,
	"./page-next.svg": 3998,
	"./page-prev.svg": 3999,
	"./phone.svg": 4000,
	"./pickup.svg": 4001,
	"./pneumaticTrailer.svg": 4002,
	"./policy.svg": 4003,
	"./popupClose.svg": 4004,
	"./popupConfirm.svg": 4005,
	"./popupDelete.svg": 4006,
	"./privatePassenger.svg": 4007,
	"./qbdii.svg": 4008,
	"./receipts_active.svg": 4009,
	"./receipts_active_es.svg": 4010,
	"./reeferTrailer.svg": 4011,
	"./refreshCircle.svg": 4012,
	"./renewal.svg": 4013,
	"./repair.svg": 4014,
	"./reportIcon.svg": 4015,
	"./reports.svg": 4016,
	"./save-regular.svg": 4017,
	"./scoreCard.svg": 4018,
	"./searchGrey.svg": 4019,
	"./selectedConnection.svg": 4020,
	"./share.svg": 4021,
	"./sixPin.svg": 4022,
	"./sort.svg": 4023,
	"./speedometer.svg": 4024,
	"./spotlightGreen.svg": 4025,
	"./spotlightGrey.svg": 4026,
	"./spotlightRed.svg": 4027,
	"./straightTruck.svg": 4028,
	"./supportIcon.svg": 4029,
	"./switch.svg": 4030,
	"./tankerTrailer.svg": 4031,
	"./tick.svg": 4032,
	"./time.svg": 4033,
	"./timePicker.svg": 4034,
	"./toggle-off.svg": 4035,
	"./toggle-on.svg": 4036,
	"./tools.svg": 4037,
	"./tractorDayCab.svg": 4038,
	"./tractorSleeper.svg": 4039,
	"./undelete.svg": 4040,
	"./unsaved.svg": 4041,
	"./update.svg": 4042,
	"./upload.svg": 4043,
	"./usdot.svg": 4044,
	"./user.svg": 4045,
	"./userprofileIcon.svg": 4046,
	"./users.svg": 4047,
	"./vacuumTrailer.svg": 4048,
	"./vacuumTruck.svg": 4049,
	"./van.svg": 4050,
	"./vehicle-behaviour.svg": 4051,
	"./vehicle.svg": 4052,
	"./vehicleIcon.svg": 4053,
	"./viewArrow.svg": 4054,
	"./viewDocument.svg": 4055,
	"./viewReports.svg": 4056,
	"./viewStatus.svg": 4057,
	"./viewallMap.svg": 4058,
	"./violation.svg": 4059,
	"./volvo.svg": 4060,
	"./weigh_tickets_active.svg": 4061,
	"./weigh_tickets_active_es.svg": 4062,
	"./whitecheck_new.svg": 4063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3843;